module.exports = __webpack_public_path__ + "static/media/0001.b5477a02.jpg";